class RequestParameters {

    constructor() {
        let match;
        const search = /([^&=]+)=?([^&]*)/g;
        const query = window.location.search.substring(1);

        this.parameters = {};
        while (match = search.exec(query)) {
            this.parameters[this._decode(match[1])] = this._decode(match[2]);
        }
    }

    getParameter(name) {
        if (name in this.parameters) {
            return this.parameters[name];
        } else {
            return null;
        }
    }

    _decode (s) {
        const pl = /\+/g;
        return decodeURIComponent(s.replace(pl, " "));
    }

}